const KEY = "finance_dashboard_range_v1";

export function loadSavedRange() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.from || !parsed?.to) return null;
    return parsed; // { from: "YYYY-MM-DD", to: "YYYY-MM-DD", preset?: string, month?: "YYYY-MM" }
  } catch {
    return null;
  }
}

export function saveRange(range) {
  try {
    localStorage.setItem(KEY, JSON.stringify(range));
  } catch {
    // ignore
  }
}
